import { Injectable } from '@angular/core';
import { Http, QueryHandlerFor, Wrapper } from '@skylab-angular-shared/core';
import { InventoryQuery, InventoryQueryHandlerBase } from '@skylab-shared/business';

@Injectable({ providedIn: 'root'})
@QueryHandlerFor(InventoryQuery)
@Wrapper(InventoryQueryHandlerBase)
export class InventoryQueryHandler {
    public constructor(
        http: Http
    ) { }
}
